import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props
 * @returns {object}
 */
function Render(props) {
  var Component = props.component,
      render = props.render,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ['component', 'render', 'children']);

  if (Component) {
    return React.createElement(Component, otherProps);
  }

  if (render) {
    return render(otherProps);
  }

  return children ? children(otherProps) : null;
}

if (process.env.NODE_ENV !== 'production') {
  Render.propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    render: PropTypes.func,
    children: PropTypes.func
  };
}

export default Render;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/components/Render/Render.js
// module id = 779
// module chunks = 0